/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PackagesIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule="evenodd"
          d="M7.962,14.869 L7.962,7.000 L14.994,4.028 L14.994,11.547 L7.962,14.869 ZM12.000,6.000 L11.000,7.000 L11.000,12.000 L12.000,11.000 L12.000,6.000 ZM-0.016,2.960 L7.439,-0.000 L14.985,2.953 L7.446,5.988 L-0.016,2.960 ZM6.994,14.869 L-0.000,11.547 L-0.000,4.028 L6.994,7.000 L6.994,14.869 ZM4.000,7.000 L3.000,6.000 L3.000,11.000 L4.000,12.000 L4.000,7.000 Z"
          transform="translate(0.5 0.56)"/>
  ]
  getViewBox = () => '0 0 16 16'
}
